export const PERMS = {
    READ: 'drivers_types.read',
    UPDATE: 'drivers_types.update',
    DELETE: 'drivers_types.delete',
    CREATE: 'drivers_types.create',
}
